export enum EContexteMesureLingette {
    ControleEmpoussierementInitial,
    ControleEmpoussierementHorsZoneIntervention,
    ControleEmpoussierementExterieurChantier,
    ControleEmpoussierementApresNettoyage,
    SurveillancePeriodique
}